import React, { Suspense, useState } from 'react';
import { renderRoutes } from 'react-router-config';
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';

import { NavBar, TopBar } from './components';

const Dashboard = (props) => {
  const { route } = props;
  const [openNavBarMobile, setOpenNavBarMobile] = useState(false);

  const handleNavBarMobileClose = () => {
    setOpenNavBarMobile(false);
  };

  const openNavBar = () => {
    setOpenNavBarMobile(true);
  };

  return (
    <div className="h-100 w-100 d-flex flex-column overflow-hidden">
      <div className="d-lg-none">
        <TopBar openNavBar={openNavBar} />
      </div>

      <div className="d-flex flex-grow-1 overflow-hidden">
        <NavBar
          style={{
            backgroundColor: 'var(--navbar-bg)',
            zIndex: 3,
            height: '100%',
            overflow: 'hidden',
            width: '230px',  // Largura fixa
            minWidth: '230px',
            flexShrink: 0    // Impede que a barra lateral encolha
          }}
          onMobileClose={handleNavBarMobileClose}
          openMobile={openNavBarMobile}
        />

        <main className="flex-grow-1 overflow-auto" style={{ background: 'var(--content-bg)' }}>
          <Suspense fallback={<div className="text-center p-3"><Spinner animation="border" /></div>}>
            {renderRoutes(route.routes)}
          </Suspense>
        </main>
      </div>
    </div>
  );
};

Dashboard.propTypes = {
  route: PropTypes.object
};

export default Dashboard;
